import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/landing/Header";
import { Footer } from "@/components/landing/Footer";
import { LegalPage } from "@/components/legal/LegalPage";

function ImpressumPage() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header onCta={() => window.location.assign("/")} />
      <LegalPage
        title="Impressum"
        intro="Angaben gemäß § 5 TMG"
        sections={[
          {
            title: "Veritas Beratung GmbH",
            paragraphs: ["E-Mail: kontakt@veritasberatung.com"],
          },
          {
            title: "Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV",
            paragraphs: ["Veritas Beratung GmbH"],
          },
          {
            title: "Haftungsausschluss",
            paragraphs: [
              "Haftung für Inhalte: Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte übernehmen wir jedoch keine Gewähr.",
              "Haftung für Links: Diese Website kann Links zu externen Websites Dritter enthalten, auf deren Inhalte wir keinen Einfluss haben. Deshalb übernehmen wir für diese fremden Inhalte auch keine Gewähr.",
              "Urheberrecht: Die durch den Seitenbetreiber erstellten Inhalte und Werke auf dieser Website unterliegen dem deutschen Urheberrecht.",
            ],
          },
        ]}
      />
      <Footer />
    </div>
  );
}

export const Route = createFileRoute("/impressum")({
  component: ImpressumPage,
});